import {
  ICreateSendEmailInitPayload,
  ICreateSendEmailPatch,
  ICreateSendEmailReminderState,
} from '../../../types/createSendEmail';

export const INIT_CS_EMAIL = 'INIT_CS_EMAIL';
export const PATCH_CS_EMAIL = 'PATCH_CS_EMAIL';
export const RESET_CS_EMAIL = 'RESET_CS_EMAIL';

export const initCsEmail = (payload: ICreateSendEmailInitPayload) => ({
  type: INIT_CS_EMAIL,
  payload,
});

export const patchCsEmail = (payload: ICreateSendEmailPatch) => ({
  type: PATCH_CS_EMAIL,
  payload,
});

export const resetCsEmail = () => ({
  type: RESET_CS_EMAIL,
});

export const PATCH_CS_EMAIL_REMINDER = 'PATCH_CS_EMAIL_REMINDER';

export const patchCsEmailReminder = (payload: Partial<ICreateSendEmailReminderState>) => ({
  type: PATCH_CS_EMAIL_REMINDER,
  payload,
});
